<div class="app-footer-container">
  <!-- <xpo-utils-version-banner></xpo-utils-version-banner> -->
</div>
